import {
  Box,
  Button,
  Flex,
  FormControl,
  IconButton,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { DeleteIcon } from "@chakra-ui/icons";
import SuggestionAutocomplete from "../../library/components/SuggestionAutocomplete";

const SuggestedComics = ({ row, onChange }) => {
  const [suggestedComics, setSuggestedComics] = React.useState([{}]);

  const setComicAtIndex = (index, comic) => {
    const updatedComics = [...suggestedComics];
    updatedComics[index] = comic;
    setSuggestedComics(updatedComics);
    onChange(updatedComics);
  };

  const setStoryAtIndex = (index, story) => {
    const updatedComics = [...suggestedComics];
    updatedComics[index].story = story;
    setSuggestedComics(updatedComics);
    onChange(updatedComics);
  };

  const removeComicAtIndex = (index) => {
    const updatedComics = suggestedComics.filter((_, i) => i !== index);
    setSuggestedComics(updatedComics);
    onChange(updatedComics);
  };

  return (
    <Box>
      {suggestedComics.map((suggestedComic, index) => (
        <Flex
          alignItems="center"
          py="3"
          borderBottom="1px"
          borderColor="gray.900"
          key={index}
        >
          <Box pr="2">
            <IconButton
              size="xs"
              aria-label="Delete comic"
              icon={<DeleteIcon />}
              onClick={() => removeComicAtIndex(index)}
            />
          </Box>
          <Box flex="1">
            <SuggestionAutocomplete
              franchise={1}
              comic={suggestedComic}
              isLeadingInput={!suggestedComic}
              index={index}
              onSelectionChange={(currentIndex, selectedComic) => {
                setComicAtIndex(currentIndex, selectedComic);
              }}
            />
          </Box>
          <Box px="2">
            <FormControl>
              <Input
                htmlSize={4}
                placeholder="Story"
                type="text"
                name="story"
                maxLength={1}
                value={suggestedComic.story}
                onChange={(e) => {
                  setStoryAtIndex(index, e.target.value);
                }}
                onBlur={() => {}}
              />
            </FormControl>
          </Box>
        </Flex>
      ))}
      <Button
        variant="outline"
        size="sm"
        my="3"
        w={"100%"}
        onClick={() => setSuggestedComics([...suggestedComics, {}])}
      >
        Add another comic
      </Button>
    </Box>
  );
};

export default SuggestedComics;
